export class PersonalPackagesRecord {
    PersonalPackageId:number;
    PersonalPackageName:string;
    PersonalPackageCost:number;
    PersonalPackageDetails:string;
    IsActive:boolean = false;
    CreatedDt:Date;
    TimeDuration:any;
    ServiceName:any=[];
    Services = [];
    selected:boolean;
    IsSelected:boolean;
}